import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Layout from "./components/Layout";
import EnhanceAndExpand from "./pages/EnhanceAndExpand";
import ProfileManagement from "./pages/ProfileManagement";
import ContactManagement from "./pages/ContactManagement";
import DomainManagement from "./pages/DomainManagement";
import QueueManagement from "./pages/QueueManagement";
import AIChat from "./pages/AIChat";
import MapView from "./pages/MapView";
import SeedChart from "./pages/SeedChart"
import MarketingList from "./pages/MarketingList"
import ReviewFeedback from "./pages/ReviewFeedback";
import FileManager from "./pages/FileManager";
import QueueSetting from "./pages/QueueSetting";
import ContactUpload from "./pages/ContactUpload";
import AssistantInstruction from "./pages/AssistantInstruction";
import PrivateRoute from "./utils/PrivateRoute";
import ExternalRoute from "./utils/ExternalRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Brochure from "./pages/Brochure";
import Blacklist from "./pages/Blacklist";
import LinkSessions from "./pages/LinkSessions";
import ControlledKeywords from "./pages/ControlledKeywords";

// External
import LayoutExternal from "./components/LayoutExternal";
import ExternalAccessTokenEnter from "./pages/External/ExternalAccessTokenEnter"
import DashboardExternal from "./pages/External/DashboardExternal"
import DomainManagementExternal from "./pages/External/DomainManagementExternal"
import ContactManagementExternal from "./pages/External/ContactManagementExternal"
import MapViewExternal from "./pages/External/MapViewExternal"

const App = () => {
    return (
        <Router>
            <div className="App">
                <Routes>
                    {/* Public routes for unauthenticated users */}
                    <Route path="/" element={<Home />} />
                    <Route path="/external" element={<ExternalAccessTokenEnter />} />
                    <Route path="/signup" element={<SignUp />} />
                    <Route path="/signin" element={<SignIn />} />
                    <Route path="/brochure/cciilloocckk" element={<Brochure />} />

                    {/* Protected routes wrapped with Layout - External */}
                    <Route
                        element={
                            <ExternalRoute>
                                <LayoutExternal /> {/* Wrap protected routes with Layout */}
                            </ExternalRoute>
                        }
                    >
                        <Route path="/dashboard-external" element={<DashboardExternal />} />
                        <Route path="/domain-management-external" element={<DomainManagementExternal />} />
                        <Route path="/contact-management-external" element={<ContactManagementExternal />} />
                        <Route path="/map-view-external" element={<MapViewExternal />} />
                    </Route>

                    {/* Protected routes wrapped with Layout */}
                    <Route
                        element={
                            <PrivateRoute>
                                <Layout /> {/* Wrap protected routes with Layout */}
                            </PrivateRoute>
                        }
                    >
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/enhance-and-expand" element={<EnhanceAndExpand />} />
                        <Route path="/domain-management" element={<DomainManagement />} />
                        <Route path="/profile-management" element={<ProfileManagement />} />
                        <Route path="/contact-management" element={<ContactManagement />} />
                        <Route path="/queue-management" element={<QueueManagement />} />
                        <Route path="/queue-setting" element={<QueueSetting />} />
                        <Route path="/contact-upload" element={<ContactUpload />} />
                        <Route path="/assistant-instruction" element={<AssistantInstruction />} />
                        <Route path="/ai-chat" element={<AIChat />} />
                        <Route path="/feedback" element={<ReviewFeedback />} />
                        <Route path="/file-manager" element={<FileManager />} />
                        <Route path="/seed-insight" element={<SeedChart />} />
                        <Route path="/marketing-list" element={<MarketingList />} />
                        <Route path="/map-view" element={<MapView />} />
                        <Route path="/blacklist" element={<Blacklist />} />
                        <Route path="/controlled-keywords" element={<ControlledKeywords />} />
                        <Route path="/link-sessions" element={<LinkSessions />} />
                    </Route>
                </Routes>

                {/* Toast container to show toast notifications globally */}
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>
        </Router>
    );
};

export default App;
